import "@/App.css";
import Landing from "./pages/Landing";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <Landing />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
